import React from 'react';
import { HeroSection } from './components/HeroSection';
import { IntroSection } from './components/IntroSection';
import { RulesSection } from './components/RulesSection';
import { MealPlan } from './components/MealPlan';
import { ExtrasSection } from './components/ExtrasSection';
import { PersonalizeSection } from './components/PersonalizeSection';
import { ShoppingList } from './components/ShoppingList';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-wellness-cream font-sans selection:bg-wellness-sage selection:text-wellness-primary" data-id="element-0">
      <HeroSection data-id="element-1" />
      <IntroSection data-id="element-2" />
      <RulesSection data-id="element-3" />
      <MealPlan data-id="element-4" />
      <ShoppingList data-id="element-5" />
      <ExtrasSection data-id="element-6" />
      <PersonalizeSection data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}